import script from "./ModificarCuota.vue?vue&type=script&setup=true&lang=js"
export * from "./ModificarCuota.vue?vue&type=script&setup=true&lang=js"

import "./ModificarCuota.vue?vue&type=style&index=0&id=72f2840c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72f2840c"]])

export default __exports__